import * as AUTH_ACTION_TYPES from './constants.js';
import {
    push
} from 'react-router-redux/actions';
import axios from 'axios';
import {
    API
} from '../../index';
import {
    PAGE_GENERAL,
    DEFAULT_PAGE
} from '../../App';

export const getLocalStorageToken = () => {
    return localStorage.getItem('token');
}

export const saveLocalStorageToken = (token) => {
    return localStorage.setItem('token', token);
}

export const getAndDispatchUserToken = () => dispatch => {
    return new Promise((resolve, reject) => {
        const token = getLocalStorageToken();
        dispatch(setUserTokenActionType(token));
        resolve(token);
    })
};

export const saveAndDispatchUserToken = token => dispatch => {
    saveLocalStorageToken(token);
    dispatch(setUserTokenActionType(token));
}

export const validateToken = () => dispatch => {
    return new Promise((resolve, reject) => {
        return dispatch(getAndDispatchUserToken()).then(token => {
            return axios.post(API + 'authentication', {
                accessToken: token,
                strategy: 'jwt',
            }).then(response => {
                return response.data;
            }).then(response => {
                if (response.user) {
                    dispatch(saveAndDispatchUserToken(token));
                    dispatch(saveUserDataActionType(response.user));
                    return resolve(response);
                }

                return reject(response);
            }).catch(error => {
                console.error('Saved token is invalid', error);
                return reject(error);
            });
        }).catch(error => {
            console.error('No user token saved: ', error);
            return reject(error);
        });
    })
}

export const loginUserWithCredentials = params => dispatch => {
    params = {
        ...params,
        strategy: 'local',
        type: 'local',
    };

    return new Promise((resolve, reject) => {
        return axios.post(API + 'authentication', params)
            .then(response => {
                return response.data;
            })
            .then(response => {
                if (response.accessToken && response.user) {
                    dispatch(saveAndDispatchUserToken(response.accessToken));
                    dispatch(saveUserDataActionType(response.user));
                    dispatch(push(DEFAULT_PAGE));
                    return resolve(response)
                } else {
                    dispatch(removeSavedUserDataActionType());
                    return reject(response)
                }
            })
            .catch(response => {
                dispatch(removeSavedUserDataActionType());
                return reject(response)
            });
    })
};

export const saveUserDataActionType = (userData) => ({
    type: AUTH_ACTION_TYPES.AUTH_SUCCESS,
    payload: userData,
});

export const removeSavedUserDataActionType = () => ({
    type: AUTH_ACTION_TYPES.AUTH_ERROR,
    payload: null,
});

export const logoutUser = () => dispatch => {
    dispatch(saveAndDispatchUserToken(''));
    dispatch(removeSavedUserDataActionType());
    dispatch(userLogoutActionType());
    dispatch(push(PAGE_GENERAL.Login));
};

export const setUserTokenActionType = (token) => ({
    type: AUTH_ACTION_TYPES.SET_TOKEN,
    payload: token,
});

export const userLogoutActionType = () => ({
    type: AUTH_ACTION_TYPES.LOGOUT,
    payload: null,
})



// WEBPACK FOOTER //
// ./app/web/src/container/LoginPage/action.js